const pageTypeReferences = {
	REDIRECT: 'Redirect',
	RATINGS: 'Ratings',
};

export { pageTypeReferences };
